import { createFileRoute } from "@tanstack/react-router";
import { EntityListPage } from "@/components/catalog/entity-pages";
import { type EntitySearch, entitySearchSchema } from "@/lib/catalog";

export const Route = createFileRoute("/_app/_library/authors/")({
  validateSearch: entitySearchSchema,
  component: Page,
});

function Page() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <EntityListPage
      kind="authors"
      search={search}
      onSearchChange={(patch: Partial<EntitySearch>) =>
        void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: "q" in patch })
      }
    />
  );
}
